import { DEFAULT_GRADING_SCALE, passingGradeOf, percentToScaled, } from './grading-scale.js';
export const DEFAULT_GRADING_POLICY = {
    scale: DEFAULT_GRADING_SCALE,
    passingGrade: null,
};
/** La nota de aprobación con que se compara, en escalas numéricas. */
export function effectivePassingGrade(policy) {
    return policy.scale.kind === 'numeric' ? passingGradeOf(policy.scale, policy.passingGrade) : null;
}
/** Convierte un logro (0..100) a la escala del seminario: el número (en letras,
 *  los puntos de la letra). La etiqueta y si aprueba: `percentToScaled`. */
export function percentToGrade(percent, policy) {
    return percentToScaled(percent, policy.scale, policy.passingGrade).value;
}
/** Una décima para los porcentajes. El redondeo se hace UNA vez, al final:
 *  redondear antes propagaría el error al ponderar. */
function round1(n) {
    return Math.round(n * 10) / 10;
}
export function computeCourseGrade(assignments, 
/** Puntaje obtenido por tarea. Ausente o `null` = todavía sin corregir, que
 *  NO es lo mismo que un cero. */
scoreByAssignmentId, policy = DEFAULT_GRADING_POLICY) {
    let weightTotal = 0;
    let weightGraded = 0;
    let earnedWeighted = 0;
    for (const a of assignments) {
        // Una tarea sin puntaje posible no puede aportar: dividir por cero daría
        // un número y no un error, que es exactamente cómo se cuelan estos fallos.
        if (a.pointsPossible <= 0 || a.weight <= 0)
            continue;
        weightTotal += a.weight;
        const score = scoreByAssignmentId.get(a.id);
        if (score === null || score === undefined)
            continue;
        weightGraded += a.weight;
        earnedWeighted += (score / a.pointsPossible) * a.weight;
    }
    const percentCurrent = weightGraded > 0 ? (earnedWeighted / weightGraded) * 100 : null;
    const percentProjected = weightTotal > 0 ? (earnedWeighted / weightTotal) * 100 : 0;
    const current = percentCurrent === null
        ? null
        : percentToScaled(percentCurrent, policy.scale, policy.passingGrade);
    const projected = percentToScaled(percentProjected, policy.scale, policy.passingGrade);
    return {
        weightTotal,
        weightGraded,
        percentCurrent: percentCurrent === null ? null : round1(percentCurrent),
        percentProjected: round1(percentProjected),
        gradeCurrent: current?.value ?? null,
        gradeCurrentLabel: current?.label ?? null,
        gradeProjected: projected.value,
        gradeProjectedLabel: projected.label,
        passed: current?.passes ?? null,
    };
}
//# sourceMappingURL=course-grade.service.js.map